import o from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as t}from"../../../theme/index.js";const e=o.button`
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: none;
  background-color: transparent;
`;e.defaultProps=t;export{e as BackButton};
